<template>
    <div class="login-tip">
        <div class="user-box flex_box  justify-content_flex-justify " :class="pageFrom == 'company' ? 'bg_blue_064':'bg_blue_538'" v-if="isLogin">
            <div class="flex_box align-items_center">
                <img class="portrait" src="../../assets/img/user/portrait.svg">
                <p class="nickname elli1">{{ renderData.nickname }}，您好</p>
            </div>
            <div class="flex_box align-items_center" @click="signOut()">
                <div class="sign-right-desc co_fff">退出</div>
                <img class="sign-out-icon" src="../../assets/img/user/signOut.svg">
            </div>
        </div>
        <div v-else class="user-box flex_box  justify-content_flex-justify " :class="pageFrom == 'company' ? 'company_from':'default_page_from'">
            <div class="flex_box align-items_center">
                <p class="login_desc elli1" :class="{co_B0: pageFrom != 'company'}">点击成为注册会员，了解更多详情</p>
            </div>
            <div class="flex_box align-items_center" @click="login()">
                <div class="sign-right-desc">注册</div>
            </div>
        </div>
        <Alert :alertData="alertData" v-show="alertData.isAlert" @closeDialog="alertData.isAlert = false"/>
    </div>
</template>

<script>

import utils from "@/util/common";
import _co from "@/util/const";

export default {
    name: 'LoginTip',
    props: ['isLogin', "renderData", "pageFrom"],
    components:{
        Alert(render){require(["@/components/common/Alert"], render)}
    },
    data: function () {
        return {
            alertData: {
                title: '请联系客服配置帐号',
                subhead: `Email:${_co.siteConfig.email}`,
                email:_co.siteConfig.email,
                message: "",
                isAlert: false,
                confirmText:"联系客服",
                btnType: 'double', //   'single' | 'double' | 'none'
            },
        }
    },
    mounted() {
    },
    watch: {},
    methods: {
        signOut() {
            utils.removeToken()
            localStorage.clear();
            location.reload();
        },
        login() {
            this.alertData.isAlert = true;
        }

    },
}


</script>

<style lang="scss" scoped>

.login-tip {
    .user-box{
        height: 40px;
        padding: 8px 20px;
        .nickname{
            width: 250px;
            opacity: 0.8;
            font-size: 16px;
            line-height: 22px;
            color: #FFFFFF;
            letter-spacing: -0.07px;
            font-weight: 500;
            margin-left: 12px;
        }
        .sign-right-desc{
            opacity: 0.66;
            font-size: 12px;

            letter-spacing: -0.06px;
            text-align: right;
            font-weight: 500;
            margin-right: 4px;
            cursor: pointer;
        }
        .login_desc{
            opacity: 0.7;
            font-size: 12px;
            letter-spacing: 0;
            line-height: 16px;
            font-weight: 500;
        }
        .portrait{
            height: 24px;
            width: 24px;
        }
        .sign-out-icon{
            height: 12px;
            width: 12px;
        }
    }
    .default_page_from{
        background-color: #f5f8ff;
        color: #538DFF;
    }
    .company_from{
        background-color: #064ab2;
        color: #FFFFFF;
    }

}
</style>
